/**
 * Hand-curated top reviews mirrored from TrustIndex/Google for schema.org markup.
 * Static JSON-LD gives Google a reliable crawlable source — the TrustIndex
 * widget itself runs client-side and isn't always parsed by Googlebot.
 */
const TOP_REVIEWS = [
  {
    author: "Terry Belton",
    rating: 5,
    date: "2026-03-31",
    text: "Jason was excellent. Redid the wifi in our home and installed a ring camera. Would highly recommend him for any home tech projects.",
  },
  {
    author: "Jeanne Deloe",
    rating: 5,
    date: "2026-03-23",
    text: "He was Excellent! He helped us set up our new business. He streamlined many of our IT needs. We are so thankful for his expertise and patience.",
  },
  {
    author: "Laura Fisher",
    rating: 5,
    date: "2026-03-23",
    text: "Jason is absolutely amazing. He made our business start up so easy. Highly recommend his company for all your IT needs!",
  },
  {
    author: "Marco Island Homeowner",
    rating: 5,
    date: "2026-02-14",
    text: "Reliable, professional, and truly knowledgeable. Jason mounted four TVs in our new Marco Island home and set up our entire Sonos system. Looks amazing.",
  },
  {
    author: "Naples Estate Client",
    rating: 5,
    date: "2026-01-28",
    text: "The team coordinated perfectly with our interior designer. Zero visible cables, flawless UniFi network, and our Sonos sounds incredible. Worth every penny.",
  },
];

export default TOP_REVIEWS;
